import { createSlice } from "@reduxjs/toolkit";

// Tracks the chat window's collapsed/expanded state per table (keyed by gameId)
// so sibling UI (e.g. the Sit Out toggle) can anchor itself to the chat's right edge.
const chatBoxSlice = createSlice({
  name: "chatBox",
  initialState: {
    collapsed: {}, // gameId -> boolean (true = collapsed)
  },
  reducers: {
    setChatCollapsed: (state, action) => {
      const { gameId, collapsed } = action.payload;
      state.collapsed[gameId] = collapsed;
    },
  },
});

export const { setChatCollapsed } = chatBoxSlice.actions;
export default chatBoxSlice.reducer;
